import {Suspense, useEffect, useState} from "react";
import {Outlet, useLocation} from "react-router-dom";
import Loading from "../common/Loading";
import Navbar from "../common/Navbar";
import Footer from "../../pages/Footer";
import {translationsObj} from "../../translation/translation";
import {updateMeta} from "../../utils/updateMeta";
import {metaByRoute} from "../../constants/meta";

const Layout = () => {
  const [lang, setLang] = useState("en");
  const [page, setPage] = useState("home");
  const t = translationsObj[lang];
  // const dir = localStorage.getItem('i18nextLng') === 'ar' ? 'rtl' : 'ltr';
  const location = useLocation();
  const path = window.location.pathname;

  useEffect(() => {
    setPage(path);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth"
    });

    // Update meta tags based on current route
    const meta = metaByRoute[path] || metaByRoute['/'];
    // console.log(path);
    // console.log(meta.canonical);
    updateMeta(meta);
  }, [location.pathname])

  return (
    <>
      <Suspense fallback={<Loading />}>
        <div >
          <Navbar
            lang={lang}
            setLang={setLang}
            page={page}
            setPage={setPage}
            t={t}
          />
          <main className="layout">
            <Outlet />
          </main>
          <Footer/>
        </div>
      </Suspense>
    </>
  );
};

export default Layout;
